module.exports = {
  "menu.dashboard": "Tổng quan",
  "menu.admin": "Quản trị hệ thống",
  "menu.admin.user": "Tài khoản nhân viên",
  "menu.admin.client": "Đối tác tích hợp",
  "menu.admin.permission": "Phân quyền",
  "menu.admin.menu": "Gói menu chức năng",
  "menu.admin.promotion": "Gói khuyến mãi",
  "menu.admin.system-banner": "Banner hệ thống",
  "menu.admin.company-notification": "Thông báo nhà xe",
  "menu.admin.dynamic-report-editor": "Báo cáo động",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.exception": "Exception",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "Trigger",
  "menu.company": "Nhà xe",
  "menu.company.list": "Danh sách nhà xe",
  "menu.company.account": "Tài khoản nhà xe",
  "menu.company.zalo-oa-account": "Tài khoản ZaloOA",
  "menu.company.update": "Sửa thông tin nhà xe",
  "menu.company.brandname": "SMS Thương hiệu",
  "menu.company.invoice-config": "Cấu hình kết nối VDT",
  "menu.company.merchant-payment": "Cổng thanh toán",
  "menu.company.vehicle-utilities": "Tiện ích xe",
  "menu.company.company-partner": "Đối tác bán vé",
  "menu.company.report": "Báo cáo",
  "menu.company.report.balance-fluctuation": "Giao dịch ví hệ thống",
  "menu.company.report.balance-fluctuation-missing": "Kiểm tra trừ phí",
  "menu.company.report.data-sync": "Kiểm tra đồng bộ",
  "menu.company.report.services": "Dịch vụ nhà xe",
  "menu.company.report.services-used": "Dịch vụ nhà xe sử dụng",
  "menu.dashboard.workplace": "Bàn làm việc",
  "menu.dashboard.tickets": "Vé",
  "menu.dashboard.goods": "Hàng hóa",
  "menu.dashboard.analytics": "Bản đồ vé",
  "menu.dashboard.monitor": "Tài chính",
  "menu.dashboard.yearly-report": "Tổng kết năm",
  "menu.dashboard.company-yearly-report": "Tình hình công ty",
  "menu.account": "Tài khoản",
  "menu.report": "Báo cáo",
  "menu.report.company-revenue": "Doanh thu nhà xe",
  "menu.report.company-charge-wallet": "Nhà xe nạp tiền",
  "menu.report.company-payment-transaction": "Giao dịch thu phí nhà xe",
  "menu.menu": "Quản lý gói",
  "menu.menu.list": "Danh sách Menu theo gói",
  "menu.customer": "Khách hàng",
  "menu.customer.lead": "Khách hàng mới",
  "menu.customer.list": "Khách hàng tiềm năng",
  "menu.customer.care": "Chăm sóc khách hàng",
  "menu.customer.customer-status": "Trạng thái khách hàng",
  "menu.vietqr": "VietQR",
  "menu.vietqr.mbqr": "MB QR",
  "menu.vietqr.mbqr.dashboard": "Tổng quát",
  "menu.vietqr.mbqr.payments": "Giao dịch thanh toán",
  "menu.vietqr.mbqr.terminals": "Nhà xe đăng ký",
  "menu.vietqr.mbqr.refunds": "Giao dịch hoàn tiền",
  "menu.vietqr.bidvqr": "BIDV QR",
  "menu.vietqr.bidvqr.dashboard": "Tổng quát",
  "menu.vietqr.bidvqr.payments": "Giao dịch thanh toán",
  "menu.vietqr.bidvqr.terminals": "Nhà xe đăng ký",
  "menu.vietqr.bidvqr.refunds": "Giao dịch hoàn tiền",
  "menu.vietqr.napas": "NAPAS QR",
  "menu.vietqr.napas.dashboard": "Tổng quát",
  "menu.vietqr.napas.payments": "Giao dịch thanh toán",
  "menu.vietqr.napas.terminals": "Nhà xe đăng ký",
  "menu.vietqr.vpb-qr": "VPBank QR",
  "menu.vietqr.vpb-qr.dashboard": "Tổng quát",
  "menu.vietqr.vpb-qr.payments": "Giao dịch thanh toán",
  "menu.vietqr.vpb-qr.terminals": "Nhà xe đăng ký",
  "menu.vietqr.vpb-qr.vpbank-customer-sdk-log": "Khách hàng đăng ký TK VPBank",
  "menu.vietqr.cloud-speaker": "Loa thanh toán",
  "menu.partner-devices": "Thiết bị đối tác",
  "menu.partner-devices.lhv-partner": "Loa Heo Vàng",
  "menu.partner-devices.dashboard": "Tổng quan",
  "menu.partner": "Đối tác bán vé",
  "menu.partner.list": "Danh sách",
  "menu.partner.brandname": "SMS Thương hiệu",
  "menu.transit-with-partner": "Trung chuyển",
  "menu.transit-with-partner.dashboard": "Tổng quát",
  "menu.transit-with-partner.coordination": "Điều phối Trung chuyển",
  "menu.transit-with-partner.coordination2": "Điều phối Trung chuyển 2",
  "menu.transit-with-partner.coordination-history": "Lịch sử điều phối",
  "menu.transit-with-partner.transit-dispatch-display-config": "Cấu hình hiển thị thông tin điều phối",
  "menu.transit-with-partner.anvui-stop-point": "Điểm dừng Trung chuyển",
  "menu.transit-with-partner.transit-config": "Cấu hình phí trung chuyển",
  "menu.transit-with-partner.report": "Báo cáo Trung chuyển",
  "menu.transit-with-partner.report.transit-ticket": "Báo cáo Trung chuyển theo vé",
  "menu.transit-with-partner.report.staff-revenue": "Báo cáo doanh thu theo nhân viên",
  "menu.transit-with-partner.report.company-revenue": "Báo cáo Doanh thu theo nhà xe",
  "menu.transit-with-partner.station-report": "Báo cáo Trung chuyển Bến xe",
  "menu.transit-with-partner.station-report.tickets": "Báo cáo vé trung chuyển bến xe",
  "menu.transit-with-partner.station-report.company-revenue": "Báo cáo doanh thu nhà xe theo bến",
  "menu.transit-with-partner.surcharge-rules": "Cấu hình Phụ thu",
  "menu.landing": "Quản trị Web An Vui",
  "menu.landing.news": "Tin tức",
  "menu.landing.recruit": "Tuyển dụng",
  "menu.company.feedback": "Phản hồi nhà xe"
}
